module.exports = __webpack_public_path__ + "static/guardianshipPrice-9945a10f95e6e06902190e8c84ad29c9.pdf";